import { environment } from '../config/environment';
import { getApiHeadersForGet } from './apiUtils';

export interface ContestProposalSummary {
  contest_id: string;
  proposal_id?: string | null;
  proposal_number?: string | null;
  status?: string | null;
  quarter?: string | null;
  sponsor_name?: string | null;
  sponsor_logo_url?: string | null;
  total_investment_usd?: number | null;
  total_reach_est_k?: number | null;
  prize_pool_usd?: number | null;
  updated_at?: string | null;
}

/**
 * Enriquece concursos con `linkedProposal` (resumen de la propuesta del
 * Sponsorship Builder enlazada, si existe) usando una sola petición bulk en
 * lugar de N llamadas por concurso.
 */
export async function attachProposalSummariesBulk(contestsData: any[]): Promise<any[]> {
  if (!Array.isArray(contestsData) || contestsData.length === 0) {
    return [];
  }

  const contestIds = [...new Set(contestsData.map((contest) => contest?.id).filter(Boolean))] as string[];
  if (contestIds.length === 0) {
    return contestsData;
  }

  try {
    const url = `${environment.apiBaseUrl}/contest-proposal-content/summaries?contestIds=${encodeURIComponent(contestIds.join(','))}`;
    const response = await fetch(url, { headers: getApiHeadersForGet() });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    const summaries: Record<string, ContestProposalSummary> = data?.summaries || {};

    return contestsData.map((contest) => ({
      ...contest,
      linkedProposal: summaries[contest.id] || null,
    }));
  } catch (error) {
    console.error('Error loading bulk proposal summaries, continuing without them:', error);
    return contestsData.map((contest) => ({
      ...contest,
      linkedProposal: contest.linkedProposal ?? null,
    }));
  }
}
